import { DataSender } from '../loaders'
/**
* ChangeLanguageModal
*/

class ChangeLanguageModal {
    constructor(target, callback) {
        if(!target || !target.length) {
            window.activeModalInstance = null;
            return;
        }

        this.target = target;
        this.callback = (callback) ? callback : null;
        this.currentLanguage = null;
        this.locked = false;

        this.loadModal();
    }

    loadModal() {
        var that = this;

        this.target.html('<div class="activity-indicator gray"></div>');
        this.target.show();

        new DataSender({
            url: '/change-language/load/',

            success: function(data) {
                if(data.status) {
                    that.currentLanguage = data.current_language;
                    that.target.html(data.html);
                    that.initModal();
                }
            },

            error: function() {
                that.closeModal();
            }
        });
    }

    initModal() {
        var that = this;

        that.target.on('hidden.bs.modal', function () {
            that.closeModal();
        });

        this.languageButtons = this.target.find('.modal-body').find('a');
        this.languageButtons.filter('[data-language="' + this.currentLanguage + '"]').addClass('selected');

        this.languageButtons.bind('click', function() {
            var button = $(this);

            if(!that.locked) {
                if(!button.hasClass('selected')) {
                    that.locked = true;
                    button.addClass('loading').append('<div class="activity-indicator gray"></div>');

                    new DataSender({
                        data: { language: button.data('language') },
                        url: '/change-language/',

                        success: function(data) {
                            if(data.status) {
                                window.setTimeout(function() {
                                    that.languageButtons.removeClass('selected');
                                    button.find('.activity-indicator').remove();
                                    button.removeClass('loading').addClass('selected');

                                    window.location.reload();
                                }, 250);
                            }
                        },

                        error: function() {
                            window.setTimeout(function() {
                                that.locked = false;
                                button.find('.activity-indicator').remove().removeClass('loading');
                            }, 250);
                        }
                    });
                }
            }

            return false;
        });
    }

    closeModal() {
        console.log(this.target)
        // this.target.hide();
        // this.target.html('');

        if(this.callback) {
            this.callback();
        }

        window.activeModalInstance = null;
    }
}

export { ChangeLanguageModal }
